"use strict";require('@ebay/skin/page-notice');
require('@ebay/skin/icon');